import React from 'react';

const Feedback = ({severity, message}) => (
    <div className={`control`}>
        <input type="text" className={`wac-input hom hod ${severity}`} />
        <span className='wac-input-feedback'>{message}</span>
    </div>
);

export default Feedback;